// extracted by mini-css-extract-plugin
module.exports = {"section":"sqCxi","subTitle":"dr2EC","channelDescription":"_3zOsA","descriptionContent":"RZUlO","errorBox":"_11eP9","errorTitle":"_2rcmS","errorLink":"_26cmB"};